import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { ThemeSwitcherProvider } from "react-css-theme-switcher"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import React from "react"

import store from "./store"
import Layouts from "./layouts"
import history from "./history"
import { THEME_CONFIG } from "./configs/AppConfig"
import { SnackbarProvider, enqueueSnackbar } from "notistack"

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}

// Create a client.
// networkMode "always": React Query exécute toujours queryFn/mutationFn même
// quand navigator.onLine est false. Sans ça (défaut "online"), les requêtes
// sont MISES EN PAUSE hors ligne et la branche offline (lecture IndexedDB)
// ne s'exécute jamais → spinner infini en mode hors ligne réel.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { networkMode: "always" },
    mutations: { networkMode: "always" },
  },
})

function App() {
  // const cached = localStorage.getItem("OFFLINE_CACHE_DONE")
  // if (cached === undefined) {
  //   localStorage.setItem("OFFLINE_CACHE_DONE", "false")
  // }
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider>
          <Provider store={store}>
            <BrowserRouter history={history}>
              <ThemeSwitcherProvider
                defaultTheme={THEME_CONFIG.currentTheme}
                insertionPoint="styles-insertion-point"
                themeMap={themes}
              >
                <Layouts />
              </ThemeSwitcherProvider>
            </BrowserRouter>
          </Provider>
        </SnackbarProvider>
      </QueryClientProvider>
    </div>
  )
}

export default App
